import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حساب مستوى السكر في الدم - حاسب سكر الدم الطبيعي";
const DESCRIPTION =
  "حاسبة مستوى السكر في الدم: حدد إذا كانت نتائجك ضمن المعدل الطبيعي (عشوائي، صائم، بعد الأكل، أو تراكمي) حسب نوع الفحص! أداة طبية مع تفسير مفصل لكل حالة - مع نصائح لضبط السكر لمرضى السكري وما قبل السكري.";
const KEYWORDS =
  "حاسبة السكر, مستوى السكر في الدم, فحص السكر العشوائي, فحص السكر الصيامي";
const OG_URL = "https://do-calculate.com/calculator/ar/blood-sugar-calculator/";
function BloodSugarCalculator() {
  const [sugarLevel, setSugarLevel] = useState("");
  const [testType, setTestType] = useState("فحص السكر العشوائي");
  const [result, setResult] = useState("");
  const [alertClass, setAlertClass] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (sugarLevel) {
        const level = parseFloat(sugarLevel);
        let normalRange;
        let minLevel, maxLevel;
        let message;
        if (testType === "فحص السكر العشوائي") {
          normalRange = "140-200 mg/dl";
          minLevel = 140;
          maxLevel = 200;
        } else if (testType === "فحص السكر الصيامي") {
          normalRange = "70-100 mg/dl";
          minLevel = 70;
          maxLevel = 100;
        }
        if (level < minLevel) {
          message = `تحذير: المستوى المدخل ${level} mg/dl أقل من النسبة الطبيعية لـ ${testType} (${normalRange}).`;
          setAlertClass("alert alert-warning");
        } else if (level > maxLevel) {
          message = `تحذير: المستوى المدخل ${level} mg/dl أعلى من النسبة الطبيعية لـ ${testType} (${normalRange}).`;
          setAlertClass("alert alert-warning");
        } else {
          message = `ممتاز: المستوى المدخل ${level} mg/dl ضمن النسبة الطبيعية لـ ${testType} (${normalRange}).`;
          setAlertClass("alert alert-success");
        }
        setResult(message);
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حاسبة سكر الدم الذكية هي أداة مفيدة وموثوقة تساعدك على تحديد
                  مستوى سكر دمك بسهولة. ما عليك سوى إدخال قراءة جهاز قياس السكر
                  في الدم بالمليغرام لكل ديسيلتر (mg/dl) واختيار نوع الفحص الذي
                  قمت بإجرائه (عشوائي أو صيام). ستوفر لك حاسبتنا النتائج الفورية
                  مع شرح بسيط لمعناها. سواء كنت مصابًا بالسكري أو ترغب فقط في
                  مراقبة صحتك، فإن حاسبتنا هي أداة قيمة للمحافظة على التحكم
                  الأمثل في سكر الدم.
                </p>
                <p>لحساب مستوى السكر يمكنك اتباع الخطوات التالية:</p>
                <ul>
                  <li>
                    ادخل مستوى السكر في الدم بالمليغرام لكل ديسيلتر (mg/dl).
                  </li>
                  <li>
                    اختر نوع الفحص: فحص السكر العشوائي أو فحص السكر الصيامي.
                  </li>
                </ul>
                <p>تم تطوير هذه الحاسبة لتسهيل معرفة مستوى السكر في الدم.</p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="level">
                          ادخل مستوى السكر
                        </label>
                      </b>
                      <input
                        id="level"
                        type="number"
                        value={sugarLevel}
                        onChange={(e) => setSugarLevel(e.target.value)}
                        placeholder="أدخل مستوى السكر"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="type">
                          اختر نوع الفحص
                        </label>
                      </b>
                      <select
                        id="type"
                        className="form-control"
                        value={testType}
                        onChange={(e) => setTestType(e.target.value)}
                        style={{ width: "75%" }}
                      >
                        <option value="فحص السكر العشوائي">
                          فحص السكر العشوائي
                        </option>
                        <option value="فحص السكر الصيامي">
                          فحص السكر الصيامي
                        </option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className={alertClass}>
                      <h4>النتيجة:</h4>
                      <p className="text-black">{result}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      ما هو مستوى السكر الطبيعي؟
                    </h2>
                  </u>
                  <p>مستوى السكر الطبيعي يعتمد على نوع الفحص.</p>
                  <p>
                    في حالة فحص السكر العشوائي، النسبة الطبيعية هي بين 80 و 140
                    mg/dl.
                  </p>
                  <p>
                    في حالة فحص السكر الصيامي، النسبة الطبيعية هي بين 70 و 100
                    mg/dl.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    تأكد من اتباع نصائح الطبيب للحفاظ على مستوى السكر الطبيعي.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      ما هي الفروقات بين الفحصين؟
                    </h2>
                  </u>
                  <p>
                    الفحص العشوائي يمكن إجراؤه في أي وقت بينما الفحص الصيامي
                    يتطلب صيام لفترة محددة.
                  </p>
                  <ul>
                    <li>فحص السكر العشوائي: لا يتطلب صيام.</li>
                    <li>فحص السكر الصيامي: يتطلب صيام 8-12 ساعة.</li>
                  </ul>
                  <p>يعتمد اختيار الفحص على توجيهات الطبيب واحتياجات المريض.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    التزم بنصائح الطبيب للحصول على أفضل نتائج.
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BloodSugarCalculator;
